import http from '@/utils/http'
import qs from 'qs'

export function getCommodityClasses() {
	return http({
      url: '/category/all.do',
      method: 'get'
    })
}

export function getCommodityProps(cid) {
	return http({
      url: '/category/listByCid.do?cid='+cid,
      method: 'get'
    })
}

export function addCommodity(cid,name,mainImage,customerProps,saleProps,binds,skuList) {
	const data = {cid,name,mainImage,customerProps,saleProps,binds,skuList}
	return http({
	    url: '/product/add.do',
	    method: 'post',
	    headers:{
	    	'Content-Type':'application/json;charset=UTF-8'
	    },
	    data
	})
}

